export function closestScrollableAncestor(element: HTMLElement): HTMLElement | null {
  let current: HTMLElement | null = element;

  while (current && current !== document.body) {
    const { overflowY } = getComputedStyle(current);

    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current;
    }

    current = current.parentElement;
  }

  return null;
}
